<template>
  <v-navigation-drawer app :value="isShow">
    <v-toolbar dark :color="$ENV.VUE_APP_HEADER_COLOR">
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="headline" @click="$router.push({ name: 'home' })">{{ $ENV.VUE_APP_TITLE_SHORT }}</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-toolbar>

    <v-divider></v-divider>

    <v-list>
      <v-list-tile
        v-for="item in loggedMenuItems"
        :key="item.title"
        avatar
        @click="onClickMyAccountMenu(item)"
        :class="currentRouteName == item.router_name ? 'active-menu' : ''"
      >
        <v-list-tile-action>
          <v-icon v-text="item.icon"></v-icon>
        </v-list-tile-action>
        <v-list-tile-title v-text="item.title"></v-list-tile-title>
      </v-list-tile>

      <!-- Reports -->
      <v-list-group :prepend-icon="NAV_MENU_REPORTS.icon" no-action>
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-content>
              <v-list-tile-title>{{
                NAV_MENU_REPORTS.title
              }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>

        <v-list-tile
          v-for="subItem in NAV_MENU_REPORTS.items"
          :key="subItem.title"
          @click="onClickMyAccountMenu(subItem)"
          :class="currentRouteName == subItem.router_name ? 'active-menu' : ''"
        >
          <v-list-tile-content>
            <v-list-tile-title>{{ subItem.title }}</v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <v-icon>{{ subItem.action }}</v-icon>
          </v-list-tile-action>
        </v-list-tile>
      </v-list-group>

      <!-- Sub Menu Example -->
      <!-- <v-list-group prepend-icon="account_circle" value="true">
        <template v-slot:activator>
          <v-list-tile>
            <v-list-tile-title>Users</v-list-tile-title>
          </v-list-tile>
        </template>
        <v-list-group no-action sub-group value="true">
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Admin</v-list-tile-title>
            </v-list-tile>
          </template>

          <v-list-tile v-for="(admin, i) in admins" :key="i" @click>
            <v-list-tile-title v-text="admin[0]"></v-list-tile-title>
            <v-list-tile-action>
              <v-icon v-text="admin[1]"></v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>

        <v-list-group sub-group no-action>
          <template v-slot:activator>
            <v-list-tile>
              <v-list-tile-title>Actions</v-list-tile-title>
            </v-list-tile>
          </template>
          <v-list-tile v-for="(crud, i) in cruds" :key="i" @click>
            <v-list-tile-title v-text="crud[0]"></v-list-tile-title>
            <v-list-tile-action>
              <v-icon v-text="crud[1]"></v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </v-list-group>
      </v-list-group> -->
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import { NAV_MENU_REPORTS } from "../mdsir/const";

const MENU_ITEMS = [
  {
    icon: "dashboard",
    title: "Dashboard",
    router_name: "home",
    perm: ["sadmin","admin"],
  },
  {
    icon: "attach_money",
    title: "Expenses",
    router_name: "expenses",
    perm: ["sadmin", "admin"],
  },
  {
    icon: "description",
    title: "Invoices",
    router_name: "invoices",
    perm: ["sadmin", "admin"],
  },
  {
    icon: "person",
    title: "Clients",
    router_name: "clients",
    perm: ["sadmin", "admin"],
  },
  {
    icon: "person",
    title: "Coordinators",
    router_name: "coordinators",
    perm: ["sadmin", "admin"],
  },
  {
    icon: "domain",
    title: "Companies",
    router_name: "companies",
    perm: ["sadmin", "admin"],
  },
  {
    icon: "checklist",
    title: "Account Heads",
    router_name: "account_heads",
    perm: ["sadmin", "admin"],
  },
  // {
  //   icon: "event_note",
  //   title: "Appointments",
  //   router_name: "appointments",
  //   perm: ["admin", "comp"],
  // },
  // {
  //   icon: "note_add",
  //   title: "Prescription Add",
  //   router_name: "prescription_add",
  //   perm: ["admin", "doctor"],
  // },
  // {
  //   icon: "description",
  //   title: "Prescriptions",
  //   router_name: "prescriptions",
  //   perm: ["admin", "doctor", "comp"],
  // },
  // {
  //   icon: "person",
  //   title: "Patients",
  //   router_name: "patients",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "medication",
  //   title: "Medicines",
  //   router_name: "medicines",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "local_pharmacy",
  //   title: "Medicine Types",
  //   router_name: "medicine_types",
  //   perm: ["admin", "doctor"],
  // },
  // {
  //   icon: "view_sidebar",
  //   title: "Sections",
  //   router_name: "prescription_left_sections",
  //   perm: ["admin", "doctor"],
  // },


  // {
  //   icon: "dynamic_feed",
  //   title: "All Transactions",
  //   router_name: "payments",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "arrow_circle_up",
  //   title: "Expenses",
  //   router_name: "expenses",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "perm_identity",
  //   title: "Contacts",
  //   router_name: "contacts",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "north_east",
  //   title: "Bills", // Purchase, employee salary, internal employe work, internet bill, electricity bill
  //   router_name: "bills",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "south_east",
  //   title: "Invoices", // service to client,
  //   router_name: "invoices",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "import_export",
  //   title: "Loans", // Take loans from internal employee, from extral org or person
  //   router_name: "loans",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "short_text",
  //   title: "Account Heads", // Soil test, employee salary
  //   router_name: "account_heads",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "money",
  //   title: "Money Accounts",
  //   router_name: "money_accounts",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "transform",
  //   title: "Money Transfers",
  //   router_name: "money_transfers",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "drag_indicator",
  //   title: "Bill Types",
  //   router_name: "bill_types",
  //   perm: ["admin"],
  // },
  // {
  //   icon: "picture_in_picture",
  //   title: "Departments",
  //   router_name: "departments",
  //   perm: ["admin"],
  // },
];

export default {
  name: "App",
  components: {},
  data() {
    return {
      myAccountMenuItems: [
        { title: "My Profile", router_name: "my_account_profile" },
        { title: "My Orders", router_name: "my_account_my_orders" },
        { title: "Track My Order", router_name: "my_account_track_my_orders" },
        { title: "Logout", router_name: "my_account_logout" },
      ],
      admins: [
        ["Management", "people_outline"],
        ["Settings", "settings"],
      ],
      cruds: [
        ["Create", "add"],
        ["Read", "insert_drive_file"],
        ["Update", "update"],
        ["Delete", "delete"],
      ],
    };
  },
  computed: {
    ...mapState({
      isShow: (state) => state.common.isNavigationDrawer,
    }),
    ...mapGetters("cart", {
      // cartProducts: "cartProducts",
      cartTotalQuantity: "cartTotalQuantity",
    }),
    loggedMenuItems: function () {
      let loggedRole =
        this.logged && this.logged.user ? this.logged.user.role : "guest";
      return MENU_ITEMS.filter((row) => row.perm.includes(loggedRole));
    },

    currentRouteName() {
      return this.$route.name;
    },
  },
  methods: {
    ...mapActions("cart", ["showCartDrawer"]),
    onLoggedOutClicked() {
      this.$store.commit("common/setLogged", {});
      this.$router.push({ name: "home" });
    },
    onClickMyAccountMenu(item) {
      switch (item.router_name) {
        case "my_account_new_order":
          this.$store.commit("common/setIsHomePageScrollToOrder", true);
          this.$router.push("/");
          break;
        default:
          this.$router.push({ name: item.router_name });
      }
    },
  },
  created() {
    this.NAV_MENU_REPORTS = NAV_MENU_REPORTS;
  },
};
</script>

<style scoped>
.active-menu {
  background-color: rgba(212, 212, 212, 0.644);
}
</style>